import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AUTH_SESSION_EXPIRED_EVENT } from '@/api/authSession';
function isProtectedPath(path) {
    return path.startsWith('/me') || path.startsWith('/admin') || path === '/checkout';
}
/** Редирект на логин при истечении сессии на защищённых страницах. */
export function AuthSessionSync() {
    const navigate = useNavigate();
    useEffect(() => {
        const onExpired = (event) => {
            const path = window.location.pathname;
            if (!isProtectedPath(path))
                return;
            const redirectTo = `${path}${window.location.search}`;
            const query = event.detail?.query;
            navigate(query ? `/login?${query}` : '/login', { replace: true, state: { redirectTo } });
        };
        window.addEventListener(AUTH_SESSION_EXPIRED_EVENT, onExpired);
        return () => window.removeEventListener(AUTH_SESSION_EXPIRED_EVENT, onExpired);
    }, [navigate]);
    return null;
}
